module.exports = __webpack_public_path__ + "img/22.84b090c7.png";